import { useRestClient } from '@/contexts/QueryProvider'

export function useGetPrivacyPolicyMarkdown(appId?: number) {
  const { getMarkdownApiGetPrivacyPolicy } = useRestClient()
  return getMarkdownApiGetPrivacyPolicy.useSuspenseQuery({ path: { applicationId: appId! } })
}

export function useSavePrivacyPolicyMarkdown(appId?: number) {
  const { postMarkdownApiSavePrivacyPolicy } = useRestClient()
  return postMarkdownApiSavePrivacyPolicy.useMutation({ path: { applicationId: appId! } })
}

export function useInvalidatePrivacyPolicyMarkdown(appId?: number) {
  const { getMarkdownApiGetPrivacyPolicy } = useRestClient()

  return () =>
    getMarkdownApiGetPrivacyPolicy.invalidateQueries({
      parameters: { path: { applicationId: appId! } },
    })
}
